<div *ngIf="backCountsCount> 0" class="back-count-label">
    <app-button styleClass="settings"
                subStyle="red"
                class="btn"
                (clicked)="onClick()"
    >
      <img src="assets/icons/icon-pill.svg" alt="icon-pill" />
        <span class="pill-text">Back-count</span> 
      <span class="chips-container">{{backCountsCount}}</span>
    </app-button>
  </div>